import React, { FunctionComponent } from 'react'
import { View } from 'react-native'

import { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { SparklesIcon } from '../../atoms/icons/SparklesIcon'
import { LoadingSkeleton } from '../../atoms/loadingSkeleton/LoadingSkeleton'
import { BodyTextSize, TextType } from '../../styles/typeStyles'
import { SpacedView } from '../../templates/content/CommonViews'
import { tID } from '../../utils/utils'
import { TypewriterDisplayType, TypewriterText } from '../typewriterText/TypewriterText'

export interface GenAiHeaderProps {
  text?: string | null
  shouldAnimate?: boolean
  estimatedLines?: { desktop: number; mobile: number }
}

export const GenAiHeader: FunctionComponent<GenAiHeaderProps> = ({ text, shouldAnimate, estimatedLines }) => {
  const {
    breakpoints: { isMobileSized },
    spacing,
  } = useTheme()

  if (text === null) {
    return <></>
  }
  const numLines = (isMobileSized ? estimatedLines?.mobile : estimatedLines?.desktop) ?? 0
  return (
    <View
      style={{
        alignSelf: 'center',
        width: 704,
        maxWidth: '100%',
        marginBottom: 32,
        minHeight: (numLines + 1) * 24,
      }}
    >
      <View
        testID={tID('GenAiHeader')}
        style={{
          flexDirection: 'column',
        }}
      >
        <SpacedView marginBottom={spacing['8px']}>
          <SparklesIcon useAIGradient />
        </SpacedView>
        {text ? (
          shouldAnimate ? (
            <TypewriterText
              textArray={[text]}
              key={text}
              textSize={BodyTextSize.DEFAULT}
              type={TextType.BODY}
              loop={false}
              millisecondsPerLetter={70}
              displayType={TypewriterDisplayType.WORD}
            />
          ) : (
            <BodyText text={text} />
          )
        ) : (
          <LoadingSkeleton width={300} />
        )}
      </View>
    </View>
  )
}
